module.exports = __webpack_public_path__ + "img/bg.5b6ef452.webp";